import { Chip, styled, useTheme } from "@mui/material";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { isPropValid } from "Infrastructure/Utils/StyleUtils";

interface EntityStatusChipProps {
  isActive: boolean;
  size?: "small" | "medium";
  variant?: "filled" | "outlined";
}

const StyledChip = styled(Chip, { shouldForwardProp: isPropValid })<{
  $backgroundColor: string;
  $textColor: string;
}>`
  background-color: ${(props) => props.$backgroundColor};
  color: ${(props) => props.$textColor};
  font-size: 12px;
  font-weight: 400;

  .MuiChip-label {
    padding: ${(props) => props.theme.spacing(0, Spacing.M)};
  }
`;

export const EntityStatusChip = ({
  isActive,
  size,
  variant = "filled",
}: EntityStatusChipProps): React.ReactNode => {
  const { t } = useResource();
  const theme = useTheme();

  const color = isActive
    ? theme.palette.success.dark
    : theme.palette.error.dark;

  return (
    <StyledChip
      size={size}
      variant={variant}
      label={
        isActive
          ? t(Resources.Common.StatusActive)
          : t(Resources.Common.StatusInactive)
      }
      $backgroundColor={variant === "outlined" ? "transparent" : color}
      $textColor={variant === "outlined" ? color : theme.palette.text.primary}
      sx={variant === "outlined" ? { borderColor: color } : undefined}
    />
  );
};
